import { Fragment, useEffect, useRef, useState } from "react";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";
import styled from "@emotion/styled";
import { LoadingButton } from "@mui/lab";
import { DateRangePicker } from "react-date-range";
import { enUS } from "date-fns/locale";
import { format, isValid } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  downloadCSVFile,
  downloadExcelFile,
  downloadInvoiceFileUpdated,
  getCurrency,
  getCustomerById,
  getCustomerLogos,
  getCustomerLoginsById,
  getCustomerStaticDataByCustID,
  getLoggedInCustomer,
  getLoggedInCustomerUser,
  getCustomerUserLogos,
  getTpBatchReport,
} from "../../redux/actions/CustomerAction";
import {
  DOWNLOAD_INVOICE_RESET,
  GET_CUSTOMER_RESET,
  GET_CUSTOMER_STATIC_DATA_RESET,
  GET_TP_BATCH_REPORT_RESET,
} from "../../Constants/Constants";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#282828",
    color: "#ffffff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#e8e9eb",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(10),
    border: "1px solid #dadde9",
  },
}));

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 5,
  textAlign: "center",
};

function createData(
  ticket_number,
  ticket_status,
  name,
  date,
  fare,
  taxes,
  pnr,
  currency,
  fop
) {
  return {
    ticket_number,
    ticket_status,
    name,
    date,
    fare,
    taxes,
    pnr,
    currency,
    fop,
  };
}

const isVoidTicket = (ticketStatus) => {
  const status = String(ticketStatus || "").trim().toUpperCase();
  return status === "VOID" || status === "REFUND";
};

const getTicketStatus = (ticket = {}) =>
  ticket?.transaction || "";

const getEticketCount = (ticket = {}) => Number(ticket?.eticket_count) || 0;

const formatFormOfPaymentLabel = (value) =>
  value === "Credit" ? "Credit Card" : value;

const parseAssignedLogoIds = (value) =>
  value
    ?.trim()
    ?.split(" ")
    ?.map((id) => parseInt(id, 10))
    ?.filter((id) => !Number.isNaN(id)) || [];

export default function NewTicketReport(props) {
  const { decodedToken, checkUserPermission } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMediumScreen = useMediaQuery("(max-width:1800px)");
  const isSmallScreen = useMediaQuery("(max-width:1500px)");
  const token = JSON.parse(localStorage.getItem("userInfo"));
  const customer_id = JSON.parse(localStorage.getItem("customer_id"));
  const customer_login_id = JSON.parse(localStorage.getItem("customer_login_id"));
  const customer_user_id = JSON.parse(localStorage.getItem("customer_user_id"));
  const ticketStatusFilter = ["ALL", "VENTE", "VOID", "REFUND"];
  const formOfPaymentFilter = [
    "ALL",
    "CASH",
    "CHECK",
    "Credit",
    "MiscFormOfPayment",
  ];
  const today = new Date();
  const todayAtMidnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const minSelectableDate = new Date(todayAtMidnight.getFullYear(), 2, 1);
  const maxSelectableDate = new Date(todayAtMidnight);
  maxSelectableDate.setDate(maxSelectableDate.getDate() - 1);
  if (maxSelectableDate < minSelectableDate) {
    maxSelectableDate.setTime(minSelectableDate.getTime());
  }
  const initialDate =
    maxSelectableDate >= minSelectableDate ? maxSelectableDate : minSelectableDate;

  const [row, setRow] = useState(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [infoAlert, setInfoAlert] = useState(false);
  const [infoAlertMessage, setInfoAlertMessage] = useState("");
  const [selectedPcc, setSelectedPcc] = useState(null);
  const [pccs, setPccs] = useState([]);
  const [dateRange, setDateRange] = useState({
    startDate: initialDate,
    endDate: initialDate,
    key: "selection",
  });
  const [totalFares, setTotalFares] = useState(null);
  const [totalTaxes, setTotalTaxes] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);
  const [totalComm, setTotalComm] = useState(null);
  const [currencies, setCurrencies] = useState({ default: "Default" });
  const [currency, setCurrency] = useState("default");
  const [responseCurrency, setResponseCurrency] = useState(null);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [ticketReportInfo, setTicketReportInfo] = useState(null);
  const [selectedTicketStatusFilter, setSelectedTicketStatusFilter] =
    useState("ALL");
  const [selectedFormOfPaymentFilter, setSelectedFormOfPaymentFilter] =
    useState("ALL");
  const [customerName, setCustomerName] = useState("");
  const [xlsxLoading, setXlsxLoading] = useState(false);
  const [xlsLoading, setXlsLoading] = useState(false);
  const [reportType, setReportType] = useState("g");
  const [iataNumber, setIataNumber] = useState(null);
  const [queryDateTime, setQueryDateTime] = useState(null);
  const [totalIssuedTicket, setTotalIssuedTicket] = useState(null);
  const [totalRefundTicket, setTotalRefundTicket] = useState(null);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [openMultiTicketInvoiceDialog, setOpenMultiTicketInvoiceDialog] =
    useState(false);
  const [pendingInvoiceRequest, setPendingInvoiceRequest] = useState(null);
  const [addServiceFee, setAddServiceFee] = useState("no");
  const [serviceFeeAmount, setServiceFeeAmount] = useState("");
  const [serviceFeeOption, setServiceFeeOption] = useState("");
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [openReportTypeReminder, setOpenReportTypeReminder] = useState(false);
  const [pendingReportType, setPendingReportType] = useState(null);
  const [invoiceLogoModalOpen, setInvoiceLogoModalOpen] = useState(false);
  const [invoiceLogoOptions, setInvoiceLogoOptions] = useState([]);
  const [selectedInvoiceLogoKey, setSelectedInvoiceLogoKey] = useState(null);
  const [invoiceFooterModalOpen, setInvoiceFooterModalOpen] = useState(false);
  const [invoiceFooterOptions, setInvoiceFooterOptions] = useState([]);
  const [selectedInvoiceFooterKey, setSelectedInvoiceFooterKey] = useState(null);
  const [showInvoiceBranding, setShowInvoiceBranding] = useState(false);

  const tableRef = useRef(null);
  const invoiceFileUrlRef = useRef(null);
  const fetchedCustomerLoginIdRef = useRef(null);
  const fetchedCustomerIdRef = useRef(null);
  const hasRequestedCurrencyRef = useRef(false);

  const { loggedInCustomerInfo } = useSelector(
    (state) => state.GetLoggedInCustomer
  );
  const { tpBatchReportData, loading } = useSelector(
    (state) => state.GetTpBatchReportData
  );
  const { currencyInfo } = useSelector((state) => state.GetCurrency);
  const { downloadCSVLoading } = useSelector((state) => state.DownloadCSVFile);
  const { loggedInCustomerUserInfo } = useSelector(
    (state) => state.GetLoggedInCustomerUser
  );
  const { customerUserLogosInfo } = useSelector(
    (state) => state.GetCustomerUserLogos
  );
  const { customerInfo } = useSelector((state) => state.GetCustomerById);
  const { customerLoginsInfo } = useSelector(
    (state) => state.GetCustomerLoginsById
  );
  const { customerLogosInfo } = useSelector((state) => state.GetCustomerLogos);
  const { customerStaticDataInfo } = useSelector(
    (state) => state.GetCustomerStaticDataByCustID
  );
  const { invoiceData, invoiceError } = useSelector(
    (state) => state.InvoiceDisplay
  );

  useEffect(() => {
    if (decodedToken?.role === "customer") {
      if (customer_id) {
        dispatch(getCustomerStaticDataByCustID(customer_id));
        if (!loggedInCustomerInfo) {
          dispatch(getLoggedInCustomer(customer_id));
        }
      }

      if (customer_login_id) {
        fetchedCustomerLoginIdRef.current = customer_login_id;
        dispatch(getCustomerLoginsById(customer_login_id));
        dispatch(getCustomerLogos(customer_login_id));
      }
    }

    if (decodedToken?.role === "customer_user" && customer_user_id) {
      if (!loggedInCustomerUserInfo) {
        dispatch(getLoggedInCustomerUser(customer_user_id));
      }
      if (!Array.isArray(customerUserLogosInfo)) {
        dispatch(getCustomerUserLogos(customer_user_id));
      }
    }
  }, [
    customer_id,
    customer_login_id,
    customer_user_id,
    customerUserLogosInfo,
    decodedToken?.role,
    dispatch,
    loggedInCustomerInfo,
    loggedInCustomerUserInfo,
  ]);

  useEffect(() => {
    if (loggedInCustomerInfo) {
      setCustomerName(loggedInCustomerInfo?.customer_name?.trim() || "");

      if (decodedToken?.role === "customer") {
        const nextPccs = loggedInCustomerInfo?.pccs?.trim()?.split(" ") || [];
        setPccs(nextPccs);
        setSelectedPcc(nextPccs.length === 1 ? nextPccs[0] : null);
      }
    }
  }, [decodedToken, loggedInCustomerInfo]);

  useEffect(() => {
    if (decodedToken?.role === "customer_user" && loggedInCustomerUserInfo) {
      const nextPccs = loggedInCustomerUserInfo?.pccs?.trim()?.split(" ") || [];
      setPccs(nextPccs);
      setSelectedPcc(nextPccs.length === 1 ? nextPccs[0] : null);

      if (
        loggedInCustomerUserInfo?.created_by &&
        fetchedCustomerLoginIdRef.current !== loggedInCustomerUserInfo.created_by
      ) {
        fetchedCustomerLoginIdRef.current = loggedInCustomerUserInfo.created_by;
        dispatch(getCustomerLoginsById(loggedInCustomerUserInfo.created_by));
        dispatch(getCustomerLogos(loggedInCustomerUserInfo.created_by));
      }
    }
  }, [decodedToken, dispatch, loggedInCustomerUserInfo]);

  useEffect(() => {
    if (
      customerLoginsInfo?.customer_id &&
      fetchedCustomerIdRef.current !== customerLoginsInfo.customer_id
    ) {
      fetchedCustomerIdRef.current = customerLoginsInfo.customer_id;
      dispatch(getCustomerById(customerLoginsInfo.customer_id));
    }
  }, [dispatch, customerLoginsInfo]);

  useEffect(() => {
    if (customerInfo) {
      setCustomerName(customerInfo?.customer_name?.trim() || "");
    }
  }, [customerInfo]);

  useEffect(() => {
    const nextInvoiceLogoOptions = [];
    const seenLogoKeys = new Set();

    const addLogoOption = ({
      key,
      logo,
      name,
      logoId = null,
      source = "customer",
      sourceLabel = "Customer logo",
    }) => {
      if (!key || !logo || seenLogoKeys.has(key)) {
        return;
      }

      seenLogoKeys.add(key);
      nextInvoiceLogoOptions.push({
        key,
        logo,
        logoId,
        name: name?.trim() || "Unnamed logo",
        source,
        sourceLabel,
      });
    };

    const defaultCustomerLogo =
      decodedToken?.role === "customer_user"
        ? customerInfo?.logo || loggedInCustomerInfo?.logo
        : loggedInCustomerInfo?.logo;

    addLogoOption({
      key: "default-customer-logo",
      logo: defaultCustomerLogo,
      name: "Default Customer Logo",
      source: "default",
      sourceLabel: "Default logo",
    });

    if (
      decodedToken?.role === "customer_user" &&
      Array.isArray(customerUserLogosInfo)
    ) {
      customerUserLogosInfo.forEach((logoItem) => {
        addLogoOption({
          key: `customer-user-${logoItem.logo_id}`,
          logo: logoItem.logo,
          name: logoItem.name,
          logoId: logoItem.logo_id,
          source: "customer_user",
          sourceLabel: "Customer user logo",
        });
      });
    }

    if (Array.isArray(customerLogosInfo)) {
      customerLogosInfo.forEach((logoItem) => {
        addLogoOption({
          key: `customer-${logoItem.logo_id}`,
          logo: logoItem.logo,
          name: logoItem.name,
          logoId: logoItem.logo_id,
          source: "customer",
          sourceLabel: "Customer logo",
        });
      });
    }

    setInvoiceLogoOptions(nextInvoiceLogoOptions);
  }, [
    customerInfo?.logo,
    customerLogosInfo,
    customerUserLogosInfo,
    decodedToken?.role,
    loggedInCustomerInfo?.logo,
  ]);

  useEffect(() => {
    if (!invoiceLogoOptions.length) {
      setSelectedInvoiceLogoKey(null);
      return;
    }

    const selectedLogoStillExists = invoiceLogoOptions.some(
      (logoItem) => logoItem.key === selectedInvoiceLogoKey
    );

    if (!selectedLogoStillExists) {
      setSelectedInvoiceLogoKey(invoiceLogoOptions[0].key);
    }
  }, [invoiceLogoOptions, selectedInvoiceLogoKey]);

  useEffect(() => {
    const nextInvoiceFooterOptions = [];
    const seenFooterKeys = new Set();

    const addFooterOption = ({
      key,
      logo,
      name,
      logoId = null,
      source = "customer",
      sourceLabel = "Customer footer",
    }) => {
      if (!key || !logo || seenFooterKeys.has(key)) {
        return;
      }

      seenFooterKeys.add(key);
      nextInvoiceFooterOptions.push({
        key,
        logo,
        logoId,
        name: name?.trim() || "Unnamed footer",
        source,
        sourceLabel,
      });
    };

    const customerUserFooterIds = parseAssignedLogoIds(
      loggedInCustomerUserInfo?.footer
    );
    const customerFooterIds = parseAssignedLogoIds(customerLoginsInfo?.footer);

    if (
      decodedToken?.role === "customer_user" &&
      Array.isArray(customerUserLogosInfo)
    ) {
      customerUserLogosInfo
        .filter((logoItem) => customerUserFooterIds.includes(logoItem.logo_id))
        .forEach((logoItem) => {
          addFooterOption({
            key: `customer-user-footer-${logoItem.logo_id}`,
            logo: logoItem.logo,
            name: logoItem.name,
            logoId: logoItem.logo_id,
            source: "customer_user",
            sourceLabel: "Customer user footer",
          });
        });
    }

    if (Array.isArray(customerLogosInfo)) {
      customerLogosInfo
        .filter((logoItem) => customerFooterIds.includes(logoItem.logo_id))
        .forEach((logoItem) => {
          addFooterOption({
            key: `customer-footer-${logoItem.logo_id}`,
            logo: logoItem.logo,
            name: logoItem.name,
            logoId: logoItem.logo_id,
            source: "customer",
            sourceLabel: "Customer footer",
          });
        });
    }

    setInvoiceFooterOptions(nextInvoiceFooterOptions);
  }, [
    customerLogosInfo,
    customerLoginsInfo?.footer,
    customerUserLogosInfo,
    decodedToken?.role,
    loggedInCustomerUserInfo?.footer,
  ]);

  useEffect(() => {
    if (!invoiceFooterOptions.length) {
      setSelectedInvoiceFooterKey(null);
      return;
    }

    const selectedFooterStillExists = invoiceFooterOptions.some(
      (footerItem) => footerItem.key === selectedInvoiceFooterKey
    );

    if (!selectedFooterStillExists) {
      setSelectedInvoiceFooterKey(invoiceFooterOptions[0].key);
    }
  }, [invoiceFooterOptions, selectedInvoiceFooterKey]);

  useEffect(() => {
    if (currencyInfo) {
      setCurrencies((prevState) => ({ ...prevState, ...currencyInfo }));
      setCurrency("default");
    }
  }, [currencyInfo]);

  useEffect(() => {
    if (invoiceData) {
      setLoadingRowId(null);
      setOpenInvoiceModal(true);
    }
  }, [invoiceData]);

  useEffect(() => {
    invoiceFileUrlRef.current = invoiceData?.fileUrl || null;
  }, [invoiceData]);

  useEffect(() => {
    if (
      reportGenerated &&
      Array.isArray(tpBatchReportData) &&
      tpBatchReportData.length === 0
    ) {
      setInfoAlertMessage(
        "Oops! No data available for the selected date range or currency. Please try adjusting your dates or currency and search again."
      );
      setSnackOpen(true);
      setInfoAlert(true);
      setReportGenerated(false);
    }
  }, [reportGenerated, tpBatchReportData]);

  useEffect(() => {
    if (!ticketReportInfo) {
      setRow(null);
      setTotalFares(null);
      setTotalTaxes(null);
      setTotalAmount(null);
      setTotalComm(null);
      setIataNumber(null);
      return;
    }

    const clonedTicketReportData = JSON.parse(JSON.stringify(ticketReportInfo));

    if (selectedTicketStatusFilter === "ALL") {
      const issuedTickets = clonedTicketReportData.filter(
        (ticket) => ticket.transaction === "VENTE"
      );
      const refundTickets = clonedTicketReportData.filter(
        (ticket) => ticket.transaction === "REFUND"
      );

      const totalIssued = issuedTickets
        .reduce((acc, item) => {
          const taxes = Number(item?.total_taxe) || 0;
          const ht = Number(item?.ht) || 0;
          return acc + taxes + ht;
        }, 0)
        .toFixed(2);

      const totalRefund = refundTickets
        .reduce((acc, item) => {
          const taxes = Number(item?.total_taxe) || 0;
          const ht = Number(item?.ht) || 0;
          return acc + taxes + ht;
        }, 0)
        .toFixed(2);

      setTotalIssuedTicket(totalIssued);
      setTotalRefundTicket(totalRefund);
    }

    const newRows = clonedTicketReportData.map((value) =>
      createData(
        value.number,
        value.transaction,
        value.traveler_name,
        value.ticket_date,
        value.ht?.toString().trim() ? value.ht : 0,
        value.total_taxe,
        value.pnr,
        value.device,
        value.formOfPayment
      )
    );
    setRow(newRows);

    if (currency === "default") {
      const nextResponseCurrency = clonedTicketReportData.find(
        (item) => item?.device
      )?.device;
      setResponseCurrency(nextResponseCurrency || null);
    }

    const nextTotalFares = clonedTicketReportData
      .reduce((acc, item) => acc + (Number(item?.ht) || 0), 0)
      .toFixed(2);

    const nextTotalTaxes = clonedTicketReportData
      .reduce((acc, item) => acc + (Number(item?.total_taxe) || 0), 0)
      .toFixed(2);

    const nextTotalAmount = clonedTicketReportData
      .reduce((acc, item) => {
        const taxes = Number(item?.total_taxe) || 0;
        const ht = Number(item?.ht) || 0;
        return acc + taxes + ht;
      }, 0)
      .toFixed(2);

    const nextIataNumber = clonedTicketReportData.find(
      (item) => item?.iata_number
    )?.iata_number;

    const nextTotalComm = clonedTicketReportData
      .reduce((acc, item) => acc + (Number(item?.commission) || 0), 0)
      .toFixed(2);

    setTotalFares(nextTotalFares);
    setTotalTaxes(nextTotalTaxes);
    setTotalAmount(nextTotalAmount);
    setIataNumber(nextIataNumber || null);
    setTotalComm(nextTotalComm);

    setTimeout(() => {
      if (tableRef.current) {
        tableRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  }, [currency, selectedTicketStatusFilter, ticketReportInfo]);

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    if (!hasRequestedCurrencyRef.current) {
      dispatch(getCurrency());
      hasRequestedCurrencyRef.current = true;
    }
  }, [dispatch, navigate, token]);

  useEffect(() => {
    if (!token) {
      return;
    }

    if (loggedInCustomerInfo) {
      if (
        !checkUserPermission(103, "can_view") ||
        !loggedInCustomerInfo?.is_report_enabled
      ) {
        localStorage.setItem("lastVisitedPath", "/dashboard");
        navigate("/dashboard");
        return;
      }
    }

    if (loggedInCustomerUserInfo && !checkUserPermission(103, "can_view")) {
      localStorage.setItem("lastVisitedPath", "/dashboard");
      navigate("/dashboard");
      return;
    }
  }, [
    checkUserPermission,
    loggedInCustomerInfo,
    loggedInCustomerUserInfo,
    navigate,
    token,
  ]);

  useEffect(() => {
    if (!Array.isArray(tpBatchReportData)) {
      setRow(null);
      setTicketReportInfo(null);
      setTotalIssuedTicket(null);
      setTotalRefundTicket(null);
      return;
    }

    let filteredTickets = JSON.parse(JSON.stringify(tpBatchReportData));

    if (selectedTicketStatusFilter !== "ALL") {
      filteredTickets = filteredTickets.filter(
        (ticket) => ticket.transaction === selectedTicketStatusFilter
      );
      setTotalIssuedTicket(null);
      setTotalRefundTicket(null);
    } else {
      const issuedTickets = tpBatchReportData.filter(
        (ticket) => ticket.transaction === "VENTE"
      );
      const refundTickets = tpBatchReportData.filter(
        (ticket) => ticket.transaction === "REFUND"
      );

      setTotalIssuedTicket(
        issuedTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            return acc + taxes + ht;
          }, 0)
          .toFixed(2)
      );
      setTotalRefundTicket(
        refundTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            return acc + taxes + ht;
          }, 0)
          .toFixed(2)
      );
    }

    if (selectedFormOfPaymentFilter !== "ALL") {
      filteredTickets = filteredTickets.filter(
        (ticket) =>
          formatFormOfPaymentLabel(ticket.formOfPayment) ===
          formatFormOfPaymentLabel(selectedFormOfPaymentFilter)
      );
    }

    setTicketReportInfo(filteredTickets);
  }, [selectedFormOfPaymentFilter, selectedTicketStatusFilter, tpBatchReportData]);

  useEffect(() => {
    dispatch({ type: GET_CUSTOMER_RESET });
    dispatch({ type: GET_CUSTOMER_STATIC_DATA_RESET });
    dispatch({ type: GET_TP_BATCH_REPORT_RESET });
    dispatch({ type: DOWNLOAD_INVOICE_RESET });

    return () => {
      if (invoiceFileUrlRef.current) {
        URL.revokeObjectURL(invoiceFileUrlRef.current);
      }
      dispatch({ type: DOWNLOAD_INVOICE_RESET });
      dispatch({ type: GET_TP_BATCH_REPORT_RESET });
    };
  }, [dispatch]);

  const handleSnackClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setErrorAlert(false);
    setInfoAlert(false);
  };

  const resetInvoicePreview = () => {
    if (invoiceData?.fileUrl) {
      URL.revokeObjectURL(invoiceData.fileUrl);
    }
    dispatch({ type: DOWNLOAD_INVOICE_RESET });
  };

  const clearReportData = () => {
    setReportGenerated(false);
    setRow(null);
    setTicketReportInfo(null);
    setTotalFares(null);
    setTotalTaxes(null);
    setTotalAmount(null);
    setTotalComm(null);
    setResponseCurrency(null);
    setIataNumber(null);
    setQueryDateTime(null);
    setTotalIssuedTicket(null);
    setTotalRefundTicket(null);
    setSelectedTicketStatusFilter("ALL");
    setSelectedFormOfPaymentFilter("ALL");
    setLoadingRowId(null);
    setOpenInvoiceModal(false);
    setOpenMultiTicketInvoiceDialog(false);
    setPendingInvoiceRequest(null);
    setAddServiceFee("no");
    setServiceFeeAmount("");
    setServiceFeeOption("");
    resetInvoicePreview();
    dispatch({ type: GET_TP_BATCH_REPORT_RESET });
  };

  const handleDateRangeChange = (ranges) => {
    if (!ranges?.selection) {
      return;
    }

    const { startDate, endDate } = ranges.selection;
    if (!startDate || !endDate || !isValid(startDate) || !isValid(endDate)) {
      return;
    }

    const daysDifference = (endDate - startDate) / (1000 * 3600 * 24);
    if (daysDifference <= 15) {
      setDateRange({
        startDate,
        endDate,
        key: "selection",
      });
      return;
    }

    setErrorAlertTitle("Error!");
    setErrorAlertMessage("You can only select a maximum of 16 days.");
    setSnackOpen(true);
    setErrorAlert(true);
  };

  const hasReportRows = Array.isArray(ticketReportInfo) && ticketReportInfo.length > 0;
  const selectedInvoiceLogo =
    invoiceLogoOptions.find((logoItem) => logoItem.key === selectedInvoiceLogoKey) ||
    null;
  const selectedInvoiceFooter =
    invoiceFooterOptions.find(
      (footerItem) => footerItem.key === selectedInvoiceFooterKey
    ) || null;

  const handleCSVDownload = () => {
    if (!hasReportRows) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("No data to download!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    const requestData = {
      iata_number: iataNumber || "",
      ticketReportInfo,
      total_fares: totalFares || "",
      total_taxes: totalTaxes || "",
      total_amount: totalAmount || "",
      total_comm: totalComm || "",
      currency: currency !== "default" ? currency : responseCurrency,
      query_date_time: queryDateTime || "",
      total_issued_ticket: totalIssuedTicket || "",
      total_refund_ticket: totalRefundTicket || "",
    };

    dispatch(downloadCSVFile(customerName, requestData, reportType));
  };

  const handleExcelDownload = (fileType) => {
    if (!hasReportRows) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("No data to download!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    if (fileType === "xlsx") {
      setXlsxLoading(true);
    } else {
      setXlsLoading(true);
    }

    const requestData = {
      iata_number: iataNumber || "",
      ticketReportInfo,
      total_fares: totalFares || "",
      total_taxes: totalTaxes || "",
      total_amount: totalAmount || "",
      total_comm: totalComm || "",
      currency: currency !== "default" ? currency : responseCurrency,
      query_date_time: queryDateTime || "",
      total_issued_ticket: totalIssuedTicket || "",
      total_refund_ticket: totalRefundTicket || "",
    };

    dispatch(downloadExcelFile(customerName, requestData, reportType, fileType))
      .finally(() => {
        if (fileType === "xlsx") {
          setXlsxLoading(false);
        } else {
          setXlsLoading(false);
        }
      });
  };

  const runInvoiceDownloadFlow = (
    selectedTicket,
    fileType = "pdf",
    downloadMultipleInvoice = false,
    serviceFeeDetails = {}
  ) => {
    if (!selectedTicket) {
      return;
    }

    const ticketNumber = selectedTicket.number || selectedTicket.ticket_number;
    const selectedTicketData = selectedInvoiceLogo
      ? {
          ...selectedTicket,
          header_logo: selectedInvoiceLogo.logo,
        }
      : selectedTicket;

    const selectedTicketDataWithFooter = selectedInvoiceFooter
      ? {
          ...selectedTicketData,
          footer_logo: selectedInvoiceFooter.logo,
        }
      : selectedTicketData;
    const reportCustomerId =
      decodedToken?.role === "customer"
        ? customerInfo?.customer_id
        : JSON.parse(localStorage.getItem("customer_user_id"));
    const requestData = {
      pcc_code: selectedPcc || "",
      data: selectedTicketDataWithFooter,
      customer_id: reportCustomerId,
      usertype: decodedToken?.role,
      download_multiple_invoice: downloadMultipleInvoice,
      ...serviceFeeDetails,
      ...(selectedInvoiceLogo && {
        header_logo: selectedInvoiceLogo.logo,
      }),
      ...(selectedInvoiceFooter && {
        footer_logo: selectedInvoiceFooter.logo,
      }),
    };

    setLoadingRowId(ticketNumber);
    dispatch(downloadInvoiceFileUpdated(requestData, fileType)).finally(() => {
      if (fileType === "xlsx") {
        setXlsxLoading(false);
      }
      if (fileType === "xls") {
        setXlsLoading(false);
      }
    });
  };

  const handleInvoiceDownload = (fileType, currentRow) => {
    if (!currentRow?.ticket_number) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Invalid row data!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    if (isVoidTicket(currentRow.ticket_status)) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Invoice is not available for VOID tickets.");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    const reportTickets = Array.isArray(tpBatchReportData)
      ? tpBatchReportData
      : Array.isArray(ticketReportInfo)
      ? ticketReportInfo
      : [];

    const selectedTicket = reportTickets.find(
      (item) =>
        String(item.number || "").trim() === String(currentRow.ticket_number).trim()
    );

    if (!selectedTicket) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Ticket details not found!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    if (isVoidTicket(getTicketStatus(selectedTicket))) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Invoice is not available for VOID tickets.");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    const eticketCount = getEticketCount(selectedTicket);
    setPendingInvoiceRequest({
      fileType,
      pnr: selectedTicket.pnr,
      selectedTicket,
      eticketCount,
    });
    setAddServiceFee("no");
    setServiceFeeAmount("");
    setServiceFeeOption("");
    setOpenMultiTicketInvoiceDialog(true);
  };

  const handleCloseMultiTicketInvoiceDialog = () => {
    setOpenMultiTicketInvoiceDialog(false);
    setPendingInvoiceRequest(null);
    setAddServiceFee("no");
    setServiceFeeAmount("");
    setServiceFeeOption("");
  };

  const getServiceFeeRequestData = () => {
    const shouldAddServiceFee = addServiceFee === "yes";

    return {
      add_service_fee: shouldAddServiceFee,
      service_fee_amount: shouldAddServiceFee ? Number(serviceFeeAmount) : "",
      service_fee_option: shouldAddServiceFee ? serviceFeeOption : "",
    };
  };

  const validateServiceFeeSelection = () => {
    if (addServiceFee !== "yes") {
      return true;
    }

    const normalizedAmount = String(serviceFeeAmount || "").trim();
    const parsedAmount = Number(normalizedAmount);

    if (!normalizedAmount || Number.isNaN(parsedAmount) || parsedAmount <= 0) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Please enter a valid service fee amount.");
      setSnackOpen(true);
      setErrorAlert(true);
      return false;
    }

    if (!serviceFeeOption) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage(
        "Please select how service fees should appear in the invoice."
      );
      setSnackOpen(true);
      setErrorAlert(true);
      return false;
    }

    return true;
  };

  const handleSingleInvoiceDownload = () => {
    if (!pendingInvoiceRequest?.selectedTicket) {
      handleCloseMultiTicketInvoiceDialog();
      return;
    }

    if (!validateServiceFeeSelection()) {
      return;
    }

    const serviceFeeDetails = getServiceFeeRequestData();
    runInvoiceDownloadFlow(
      pendingInvoiceRequest.selectedTicket,
      pendingInvoiceRequest.fileType,
      false,
      serviceFeeDetails
    );
    handleCloseMultiTicketInvoiceDialog();
  };

  const handleAllPaxInvoiceDownload = () => {
    if (!pendingInvoiceRequest?.selectedTicket) {
      handleCloseMultiTicketInvoiceDialog();
      return;
    }

    if (!validateServiceFeeSelection()) {
      return;
    }

    const serviceFeeDetails = getServiceFeeRequestData();
    runInvoiceDownloadFlow(
      pendingInvoiceRequest.selectedTicket,
      pendingInvoiceRequest.fileType,
      true,
      serviceFeeDetails
    );
    handleCloseMultiTicketInvoiceDialog();
  };

  const handleCloseInvoiceModal = () => {
    setOpenInvoiceModal(false);
    setLoadingRowId(null);
    resetInvoicePreview();
  };

  const handleOpenInvoiceLogoModal = () => {
    if (!invoiceLogoOptions.length) {
      return;
    }
    setInvoiceLogoModalOpen(true);
  };

  const handleCloseInvoiceLogoModal = () => {
    setInvoiceLogoModalOpen(false);
  };

  const handleOpenInvoiceFooterModal = () => {
    if (!invoiceFooterOptions.length) {
      return;
    }
    setInvoiceFooterModalOpen(true);
  };

  const handleCloseInvoiceFooterModal = () => {
    setInvoiceFooterModalOpen(false);
  };

  const invoiceBrandingOptions = [
    {
      id: "logo",
      badge: "Header branding",
      selectedItem: selectedInvoiceLogo,
      emptyMessage:
        "No saved logo found. The invoice will use the current default setup.",
      optionCount: invoiceLogoOptions.length,
      actionLabel:
        invoiceLogoOptions.length > 1
          ? "Choose Invoice Logo"
          : "Preview Invoice Logo",
      onClick: handleOpenInvoiceLogoModal,
    },
    {
      id: "footer",
      badge: "Footer branding",
      selectedItem: selectedInvoiceFooter,
      emptyMessage:
        "No saved footer logos found. The invoice will use the current default footer setup.",
      optionCount: invoiceFooterOptions.length,
      actionLabel:
        invoiceFooterOptions.length > 1
          ? "Choose Invoice Footer"
          : "Preview Invoice Footer",
      onClick: handleOpenInvoiceFooterModal,
    },
  ];

  const handleReportType = (event) => {
    const nextReportType = event.target.value;
    if (nextReportType === reportType) {
      return;
    }
    setPendingReportType(nextReportType);
    setOpenReportTypeReminder(true);
  };

  const handleConfirmReportTypeChange = () => {
    if (pendingReportType) {
      clearReportData();
      setReportType(pendingReportType);
    }
    setPendingReportType(null);
    setOpenReportTypeReminder(false);
  };

  const handleCancelReportTypeChange = () => {
    setPendingReportType(null);
    setOpenReportTypeReminder(false);
  };

  const submitHandler = () => {
    setRow(null);
    dispatch({ type: GET_TP_BATCH_REPORT_RESET });
    setReportGenerated(false);

    const { startDate, endDate } = dateRange;
    if (!selectedPcc) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Please choose the PCC or currency.");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    if (!startDate || !endDate) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Select the date range.");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    setQueryDateTime(
      `${format(startDate, "ddMMMyy").toUpperCase()}-${format(endDate, "ddMMMyy").toUpperCase()}`
    );

    const reportCustomerId =
      decodedToken?.role === "customer_user" ? customerInfo?.customer_id : customer_id;

    if (!reportCustomerId) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Customer details are not available yet. Please try again.");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    dispatch(
      getTpBatchReport(
        reportCustomerId,
        selectedPcc,
        reportType,
        format(startDate, "yyyy-MM-dd"),
        format(endDate, "yyyy-MM-dd")
      )
    ).then(() => {
      setReportGenerated(true);
    });
  };

  return (
    <Box sx={{ marginBottom: "5%" }}>
      <Container
        sx={{
          width: "100%",
          marginBottom: "5%",
          justifyContent: "center",
        }}
      >
        <Box sx={{ margin: 3, fontSize: 25, textAlign: "center" }}>
          New Ticket Report
          <Divider sx={{ marginTop: 2 }} />
        </Box>
        <Grid
          container
          mt={1}
          sx={{
            padding: 2,
            borderRadius: 2,
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Grid xs={4} mt={2}>
            <Typography>Customer Name</Typography>
          </Grid>
          <Grid xs={4} mt={2}>
            <Typography>PCC</Typography>
          </Grid>
          <Grid xs={4} mt={2}>
            <Typography>Currency</Typography>
          </Grid>
          <Grid
            xs={4}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <TextField
              size="small"
              sx={{ width: "90%" }}
              value={customerName}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid
            xs={4}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Autocomplete
              size="small"
              sx={{ width: "90%" }}
              value={selectedPcc || null}
              options={pccs || []}
              getOptionLabel={(option) => option}
              renderInput={(params) => <TextField {...params} variant="outlined" />}
              onChange={(_, value) => {
                setSelectedPcc(value || null);
              }}
            />
          </Grid>
          <Grid
            xs={4}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Autocomplete
              size="small"
              sx={{ width: "90%" }}
              value={
                currency === "default"
                  ? { 0: "default", 1: "Default" }
                  : { 0: currency, 1: currencies[currency] }
              }
              options={Object.entries(currencies || {})}
              getOptionLabel={(option) =>
                option[0] === "default" ? "Default" : `${option[0]} - ${option[1]}`
              }
              renderInput={(params) => <TextField {...params} variant="outlined" />}
              onChange={(_, value) => {
                setCurrency(value ? value[0] : "default");
              }}
            />
          </Grid>
          {customerStaticDataInfo === undefined ? (
            <Grid item xs={12} mt={3}>
              <FormControl>
                <RadioGroup
                  row
                  defaultValue={reportType}
                  value={reportType}
                  onChange={handleReportType}
                >
                  <FormControlLabel
                    value="g"
                    control={<Radio />}
                    label="General Ticket Report"
                  />
                  <FormControlLabel
                    value="c"
                    control={<Radio />}
                    label="Advanced Ticket Report"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          ) : null}
          <Grid xs={12} mt={3}>
            Please choose your Date Range
          </Grid>
          <Grid
            xs={12}
            mt={2}
            sx={{
              display: "flex",
              justifyContent: "center",
              "& .rdrDefinedRangesWrapper": {
                display: "none",
              },
              "& .rdrDateRangePickerWrapper": {
                display: "inline-block",
              },
              "& .rdrDateRangeWrapper": {
                display: "block",
              },
            }}
          >
            <DateRangePicker
              ranges={[dateRange]}
              locale={enUS}
              maxDate={maxSelectableDate}
              minDate={minSelectableDate}
              onChange={handleDateRangeChange}
              editableDateInputs={true}
              staticRanges={[]}
              inputRanges={[]}
              months={1}
              direction="horizontal"
              rangeColors={["black"]}
            />
          </Grid>
          <Grid xs={12} mt={2} sx={{ color: "red" }}>
            Please note that ticket report is allowed to generate only for 16
            days.
          </Grid>
          <Grid xs={12} mt={3} mb={1}>
            <LoadingButton
              loading={loading}
              loadingPosition="start"
              onClick={submitHandler}
              variant="contained"
              type="submit"
              sx={{ backgroundColor: "#282828", width: "20%" }}
            >
              Generate Report
            </LoadingButton>
          </Grid>
        </Grid>
      </Container>

      {loading ? (
        <Modal open={loading}>
          <Box sx={modalStyle}>
            <Grid container>
              <Grid xs={12}>
                <CircularProgress />
              </Grid>
              <Grid xs={12} mt={3} md={0}>
                <Typography>
                  Just a moment, we're preparing everything for you.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      ) : row ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          ref={tableRef}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "50%",
                justifyContent: "left",
              }}
            >
              <Autocomplete
                size="small"
                sx={{
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                }}
                options={ticketStatusFilter}
                value={selectedTicketStatusFilter}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Ticket Status" />
                )}
                onChange={(_, value) => {
                  if (value) {
                    setSelectedTicketStatusFilter(value);
                  }
                }}
              />
              <Autocomplete
                size="small"
                sx={{
                  width: isSmallScreen ? "50%" : isMediumScreen ? "40%" : "35%",
                  marginLeft: 3,
                }}
                value={selectedFormOfPaymentFilter}
                options={formOfPaymentFilter}
                getOptionLabel={(option) => formatFormOfPaymentLabel(option)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Form Of Payment"
                  />
                )}
                onChange={(_, value) => {
                  if (!value) {
                    return;
                  }
                  if (value === "ALL") {
                    setSelectedFormOfPaymentFilter(value);
                    return;
                  }
                  setSelectedFormOfPaymentFilter(
                    value === "MiscFormOfPayment"
                      ? value
                      : value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
                  );
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                width: "50%",
                justifyContent: "right",
              }}
            >
              <LoadingButton
                loading={xlsxLoading}
                loadingIndicator="Downloading..."
                onClick={() => handleExcelDownload("xlsx")}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                }}
              >
                Download .xlsx
              </LoadingButton>
              <LoadingButton
                loading={xlsLoading}
                loadingIndicator="Downloading..."
                onClick={() => handleExcelDownload("xls")}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                  marginLeft: 3,
                }}
              >
                Download .xls
              </LoadingButton>
              <LoadingButton
                loading={downloadCSVLoading}
                loadingIndicator="Downloading..."
                onClick={handleCSVDownload}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                  marginLeft: 3,
                }}
              >
                Download CSV
              </LoadingButton>
              <HtmlTooltip
                title={
                  <Fragment>
                    <Typography sx={{ fontWeight: "bold" }}>
                      This setting only takes effect after downloading the Excel
                      file.
                    </Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      Changing regional settings in Web Excel
                    </Typography>
                    <Typography>- Select File</Typography>
                    <Typography>- Select Options</Typography>
                    <Typography>- Select Regional Settings</Typography>
                    <Typography>- Select a region from the drop-down list</Typography>
                    <Typography>- Select Change</Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      Changing regional settings in Windows
                    </Typography>
                    <Typography>- Select the Start button</Typography>
                    <Typography>- Select Settings</Typography>
                    <Typography>- Select Time & language</Typography>
                    <Typography>- Select Region</Typography>
                    <Typography>
                      - Select Change date, time, or number formats
                    </Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      If your date format is already set to DD/MM/YYYY, you can
                      ignore these instructions.
                    </Typography>
                  </Fragment>
                }
                arrow
              >
                <LiveHelpIcon
                  fontSize="large"
                  sx={{ color: "red", marginLeft: 2 }}
                />
              </HtmlTooltip>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: 3,
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
            }}
          >
            <Paper
              elevation={0}
              sx={{
                mb: 3,
                borderRadius: 4,
                overflow: "hidden",
                border: "1px solid #d8e0ea",
                background:
                  "linear-gradient(180deg, #fbfcfe 0%, #f4f7fb 100%)",
                boxShadow: "0 18px 40px rgba(15, 23, 42, 0.05)",
              }}
            >
              <Box
                sx={{
                  px: { xs: 2, sm: 3 },
                  py: { xs: 2, sm: 2.5 },
                  borderBottom: showInvoiceBranding
                    ? "1px solid #e3e8ef"
                    : "none",
                  background:
                    "linear-gradient(135deg, rgba(40, 40, 40, 0.08) 0%, rgba(40, 40, 40, 0.01) 100%)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: { xs: "flex-start", sm: "center" },
                    justifyContent: "space-between",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, color: "#111827" }}
                    >
                      Invoice Branding
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 0.75,
                        color: "#5f6b7a",
                        maxWidth: 700,
                        lineHeight: 1.7,
                      }}
                    >
                      {showInvoiceBranding
                        ? "Review which header and footer will appear on generated invoices. You can switch the saved branding before opening any invoice."
                        : "Branding options are hidden. Expand this section to review or change the invoice header and footer."}
                    </Typography>
                  </Box>

                  <Button
                    variant="outlined"
                    onClick={() =>
                      setShowInvoiceBranding((prevState) => !prevState)
                    }
                    sx={{
                      px: 2,
                      py: 0.9,
                      borderRadius: 2.5,
                      fontWeight: 700,
                      textTransform: "none",
                      color: "#1f2937",
                      borderColor: "#c7d2de",
                      backgroundColor: "#ffffff",
                      "&:hover": {
                        borderColor: "#94a3b8",
                        backgroundColor: "#f8fafc",
                      },
                    }}
                  >
                    {showInvoiceBranding ? "Hide Branding Options" : "Show Branding Options"}
                  </Button>
                </Box>
              </Box>

              {showInvoiceBranding && (
                <Box
                  sx={{
                    px: { xs: 2, sm: 3 },
                    pt: { xs: 2, sm: 3 },
                    pb: { xs: 3, sm: 4 },
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                    gap: 2,
                  }}
                >
                  {invoiceBrandingOptions.map((brandingItem) => (
                    <Paper
                      key={brandingItem.id}
                      elevation={0}
                      sx={{
                        p: 2.5,
                        borderRadius: 3,
                        minHeight: 220,
                        border: "1px solid #dde5ee",
                        backgroundColor: "#ffffff",
                        display: "flex",
                        flexDirection: "column",
                        gap: 3,
                      }}
                    >
                      <Box sx={{ flexGrow: 1 }}>
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            px: 1.25,
                            py: 0.5,
                            borderRadius: "999px",
                            backgroundColor: "#eef3f8",
                            color: "#334155",
                            fontSize: 12,
                            fontWeight: 700,
                            letterSpacing: 0.4,
                            textTransform: "uppercase",
                          }}
                        >
                          {brandingItem.badge}
                        </Box>
                        <Typography
                          sx={{
                            mt: 1.5,
                            fontSize: "1rem",
                            fontWeight: 700,
                            color: "#111827",
                          }}
                        >
                          {brandingItem.title}
                        </Typography>

                        {brandingItem.selectedItem?.name ? (
                          <Fragment>
                            <Typography
                              sx={{
                                mt: 1.25,
                                fontWeight: 700,
                                color: "#0f172a",
                              }}
                            >
                              {brandingItem.selectedItem.name}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ mt: 0.5, color: "#5f6b7a", lineHeight: 1.7 }}
                            >
                              Source:{" "}
                              {brandingItem.selectedItem.sourceLabel ||
                                "Saved configuration"}
                            </Typography>
                            <Box
                              sx={{
                                mt: 2,
                                px: 2,
                                py: 1.5,
                                minHeight: 96,
                                borderRadius: 2.5,
                                border: "1px solid #e2e8f0",
                                background:
                                  "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Box
                                component="img"
                                src={`data:image/png;base64,${brandingItem.selectedItem.logo}`}
                                alt={brandingItem.selectedItem.name}
                                sx={{
                                  width: "100%",
                                  maxWidth: 190,
                                  maxHeight: 64,
                                  objectFit: "contain",
                                }}
                              />
                            </Box>
                          </Fragment>
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{ mt: 1.25, color: "#5f6b7a", lineHeight: 1.7 }}
                          >
                            {brandingItem.emptyMessage}
                          </Typography>
                        )}
                      </Box>

                      <Box
                        sx={{
                          mt: "auto",
                          pt: 2,
                          borderTop: "1px solid #edf2f7",
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          alignItems: { xs: "stretch", sm: "center" },
                          justifyContent: "space-between",
                          gap: 2,
                        }}
                      >
                        <Box>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#64748b",
                              fontWeight: 700,
                              letterSpacing: 0.5,
                              textTransform: "uppercase",
                            }}
                          >
                            Available options
                          </Typography>
                          <Typography sx={{ fontWeight: 700, color: "#111827" }}>
                            {brandingItem.optionCount}
                          </Typography>
                        </Box>

                        <Button
                          variant="contained"
                          onClick={brandingItem.onClick}
                          disabled={!brandingItem.optionCount}
                          sx={{
                            minWidth: { xs: "100%", sm: "auto" },
                            px: 2.5,
                            py: 1,
                            borderRadius: 2.5,
                            fontWeight: 700,
                            textTransform: "none",
                            backgroundColor: "#1f2937",
                            boxShadow: "none",
                            "&:hover": {
                              backgroundColor: "#111827",
                              boxShadow: "none",
                            },
                          }}
                        >
                          {brandingItem.actionLabel}
                        </Button>
                      </Box>
                    </Paper>
                  ))}
                </Box>
              )}
            </Paper>
            <TableContainer component={Paper} sx={{ borderRadius: 3, mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Currency</StyledTableCell>
                    <StyledTableCell>Total Fares</StyledTableCell>
                    <StyledTableCell>Total Taxes</StyledTableCell>
                    <StyledTableCell>Total Amount</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <StyledTableCell>
                      {currency !== "default" ? currency : responseCurrency}
                    </StyledTableCell>
                    <StyledTableCell>{totalFares}</StyledTableCell>
                    <StyledTableCell>{totalTaxes}</StyledTableCell>
                    <StyledTableCell>{totalAmount}</StyledTableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          
          <Box
            sx={{
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
              marginTop: 3,
            }}
          >
            <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>PNR</StyledTableCell>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell>Ticket Number</StyledTableCell>
                    <StyledTableCell>Fare</StyledTableCell>
                    <StyledTableCell>Taxes</StyledTableCell>
                    <StyledTableCell>Ticket Status</StyledTableCell>
                    <StyledTableCell>FOP</StyledTableCell>
                    <StyledTableCell>Currency</StyledTableCell>
                    <StyledTableCell>Invoice</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.length > 0 ? (
                    row.map((currentRow) => (
                      <StyledTableRow key={`${currentRow.ticket_number}-${currentRow.pnr}`}>
                        <StyledTableCell>{currentRow.date}</StyledTableCell>
                        <StyledTableCell>{currentRow.pnr}</StyledTableCell>
                        <StyledTableCell>
                          {String(currentRow.name || "").trim()}
                        </StyledTableCell>
                        <StyledTableCell>{currentRow.ticket_number}</StyledTableCell>
                        <StyledTableCell>{currentRow.fare || 0}</StyledTableCell>
                        <StyledTableCell>{currentRow.taxes}</StyledTableCell>
                        <StyledTableCell>{currentRow.ticket_status}</StyledTableCell>
                        <StyledTableCell>
                          {formatFormOfPaymentLabel(currentRow.fop)}
                        </StyledTableCell>
                        <StyledTableCell>{currentRow.currency}</StyledTableCell>
                        <StyledTableCell>
                          <LoadingButton
                            loading={loadingRowId === currentRow.ticket_number}
                            loadingIndicator="Preparing..."
                            disabled={isVoidTicket(currentRow.ticket_status)}
                            onClick={() => handleInvoiceDownload("pdf", currentRow)}
                            variant="contained"
                            sx={{
                              backgroundColor: "#282828",
                              width: "80%",
                              marginLeft: 3,
                            }}
                          >
                            View Invoice
                          </LoadingButton>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        colSpan={10}
                        scope="row"
                        style={{
                          textAlign: "center",
                          wordWrap: "break-word",
                          maxWidth: "100%",
                          fontSize: 15,
                        }}
                      >
                        No data found
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      ) : null}

      {errorAlert && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert onClose={handleSnackClose} severity="error" sx={{ width: "100%" }}>
            <AlertTitle>{errorAlertTitle}</AlertTitle>
            {errorAlertMessage}
          </Alert>
        </Snackbar>
      )}
      {infoAlert && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert onClose={handleSnackClose} severity="info" sx={{ width: "100%" }}>
            {infoAlertMessage}
          </Alert>
        </Snackbar>
      )}

      <Dialog
        open={openInvoiceModal}
        onClose={handleCloseInvoiceModal}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          Invoice Preview
          <IconButton
            onClick={handleCloseInvoiceModal}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ height: "75vh" }}>
          {invoiceData && !invoiceError ? (
            <object
              data={invoiceData.fileUrl}
              type="application/pdf"
              width="100%"
              height="100%"
            />
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              const link = document.createElement("a");
              link.href = invoiceData.fileUrl;
              link.download = invoiceData.fileName;
              link.click();
            }}
            disabled={!invoiceData?.fileUrl}
          >
            Download Invoice
          </Button>
          <Button variant="outlined" onClick={handleCloseInvoiceModal}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMultiTicketInvoiceDialog}
        onClose={handleCloseMultiTicketInvoiceDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Invoice Options</DialogTitle>
        <DialogContent dividers>
          {pendingInvoiceRequest?.eticketCount > 1 ? (
            <Typography>
              PNR {pendingInvoiceRequest?.pnr || "-"} has multiple e-tickets
              {pendingInvoiceRequest?.eticketCount
                ? ` (${pendingInvoiceRequest.eticketCount} found)`
                : ""}
              . Do you want to download a single invoice or an invoice for all
              pax?
            </Typography>
          ) : (
            <Typography>
              Configure the invoice options below and continue to preview the
              invoice.
            </Typography>
          )}

          <FormControl component="fieldset" sx={{ mt: 3, width: "100%" }}>
            <FormLabel>Do you want to add service fees?</FormLabel>
            <RadioGroup
              row
              value={addServiceFee}
              onChange={(event) => {
                const value = event.target.value;
                setAddServiceFee(value);
                if (value !== "yes") {
                  setServiceFeeAmount("");
                  setServiceFeeOption("");
                }
              }}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>

          {addServiceFee === "yes" && (
            <Box sx={{ mt: 2 }}>
              <TextField
                label="Service Fee Amount"
                type="number"
                size="small"
                fullWidth
                value={serviceFeeAmount}
                onChange={(event) => setServiceFeeAmount(event.target.value)}
                inputProps={{ min: 0, step: "0.01" }}
              />

              <FormControl component="fieldset" sx={{ mt: 2, width: "100%" }}>
                <FormLabel>How should service fees be handled?</FormLabel>
                <RadioGroup
                  value={serviceFeeOption}
                  onChange={(event) => setServiceFeeOption(event.target.value)}
                >
                  <FormControlLabel
                    value="included_in_final_amount_invisible"
                    control={<Radio />}
                    label="Include service fees in the final invoice amount, and do not keep them separate (invisible)"
                  />
                  <FormControlLabel
                    value="included_in_final_amount_visible"
                    control={<Radio />}
                    label="Include service fees in the final invoice amount, and keep them separate (visible)"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMultiTicketInvoiceDialog} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleSingleInvoiceDownload}
            variant={
              pendingInvoiceRequest?.eticketCount > 1 ? "outlined" : "contained"
            }
          >
            {pendingInvoiceRequest?.eticketCount > 1
              ? "Single Invoice"
              : "View Invoice"}
          </Button>
          {pendingInvoiceRequest?.eticketCount > 1 && (
            <Button onClick={handleAllPaxInvoiceDownload} variant="contained">
              Invoice For All Pax
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={invoiceLogoModalOpen}
        onClose={handleCloseInvoiceLogoModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Select Invoice Logo</DialogTitle>
        <DialogContent dividers>
          {invoiceLogoOptions.length > 0 ? (
            <Grid container spacing={2}>
              {invoiceLogoOptions.map((logoItem) => (
                <Grid item xs={12} sm={6} md={4} key={logoItem.key}>
                  <Box
                    onClick={() => setSelectedInvoiceLogoKey(logoItem.key)}
                    sx={{
                      border: "1px solid",
                      borderColor:
                        selectedInvoiceLogoKey === logoItem.key
                          ? "#282828"
                          : "divider",
                      borderRadius: 2,
                      p: 2,
                      cursor: "pointer",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1.5,
                      backgroundColor:
                        selectedInvoiceLogoKey === logoItem.key
                          ? "rgba(40, 40, 40, 0.05)"
                          : "#fff",
                    }}
                  >
                    <Radio checked={selectedInvoiceLogoKey === logoItem.key} />
                    <Box
                      component="img"
                      src={`data:image/png;base64,${logoItem.logo}`}
                      alt={logoItem.name}
                      sx={{
                        width: "100%",
                        maxWidth: 180,
                        height: 90,
                        objectFit: "contain",
                      }}
                    />
                    <Typography
                      sx={{
                        fontWeight:
                          selectedInvoiceLogoKey === logoItem.key ? 700 : 500,
                        textAlign: "center",
                      }}
                    >
                      {logoItem.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ textAlign: "center" }}
                    >
                      {logoItem.sourceLabel}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>
              No logos are available right now. The invoice will use the current
              default setup.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseInvoiceLogoModal} variant="outlined">
            Close
          </Button>
          <Button
            onClick={handleCloseInvoiceLogoModal}
            variant="contained"
            disabled={!selectedInvoiceLogo}
          >
            Use Selected Logo
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={invoiceFooterModalOpen}
        onClose={handleCloseInvoiceFooterModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Select Invoice Footer</DialogTitle>
        <DialogContent dividers>
          {invoiceFooterOptions.length > 0 ? (
            <Grid container spacing={2}>
              {invoiceFooterOptions.map((footerItem) => (
                <Grid item xs={12} sm={6} md={4} key={footerItem.key}>
                  <Box
                    onClick={() => setSelectedInvoiceFooterKey(footerItem.key)}
                    sx={{
                      border: "1px solid",
                      borderColor:
                        selectedInvoiceFooterKey === footerItem.key
                          ? "#282828"
                          : "divider",
                      borderRadius: 2,
                      p: 2,
                      cursor: "pointer",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1.5,
                      backgroundColor:
                        selectedInvoiceFooterKey === footerItem.key
                          ? "rgba(40, 40, 40, 0.05)"
                          : "#fff",
                    }}
                  >
                    <Radio checked={selectedInvoiceFooterKey === footerItem.key} />
                    <Box
                      component="img"
                      src={`data:image/png;base64,${footerItem.logo}`}
                      alt={footerItem.name}
                      sx={{
                        width: "100%",
                        maxWidth: 180,
                        height: 90,
                        objectFit: "contain",
                      }}
                    />
                    <Typography
                      sx={{
                        fontWeight:
                          selectedInvoiceFooterKey === footerItem.key ? 700 : 500,
                        textAlign: "center",
                      }}
                    >
                      {footerItem.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ textAlign: "center" }}
                    >
                      {footerItem.sourceLabel}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>
              No footer logos are available right now. The invoice will use the
              current default footer setup.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseInvoiceFooterModal} variant="outlined">
            Close
          </Button>
          <Button
            onClick={handleCloseInvoiceFooterModal}
            variant="contained"
            disabled={!selectedInvoiceFooter}
          >
            Use Selected Footer
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openReportTypeReminder}
        onClose={handleCancelReportTypeChange}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Alert</DialogTitle>
        <DialogContent dividers>
          <Typography>
            You are about to switch report options. Your existing report data
            will be cleared if you have not downloaded the files.
          </Typography>
          <Typography sx={{ mt: 2 }}>
            If you wish to continue, click OK. Otherwise, click Cancel to go back.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelReportTypeChange} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleConfirmReportTypeChange} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
